import React, { useEffect, useState } from 'react';
import { Dashboard } from './dashboard';
import { DashboardV2 } from './dashboard-v2/dashboard-v2';
import { useCustomerAPI } from '../../clients/customer-api/customer-api-client';

export const DashboardSelector = () => {
  const [dashboardV2, setDashboardV2] = useState<boolean | undefined>(undefined);

  const { getConfiguration } = useCustomerAPI();
  useEffect(() => {
    getConfiguration('CONF_DASHBOARD_V2').then((config) => {
      setDashboardV2(config?.value === '1');
    });
  }, []);

  if (dashboardV2 === undefined) {
    return <></>;
  }

  return <>{dashboardV2 ? <DashboardV2 /> : <Dashboard />}</>;
};
